import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, vendorFfmsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, vendorFfmsActions);

export default slice.reducer;
